module.exports = __webpack_public_path__ + "img/bg.b8fba18c.jpg";